// src/store/modules/sitesDiy.js
import axios from '@/plugins/axios'; // 确保您已经配置了 axios

const state = {
    cardStyles: {
        opacity: 1,
        backgroundColor: '#ffffff',
        borderColor: '#409EFF',
        boxShadow: {
            horizontal: '0px',
            vertical: '4px',
            blur: '6px',
            spread: '0px',
            color: 'rgba(0, 0, 0, 0.5)',
            inset: false,
        },
    },
};

const getters = {
    getCardStyles: (state) => state.cardStyles,
};

const actions = {
    /**
     * 获取卡片样式
     */
    async fetchCardStyles({ commit }) {
        try {
            const response = await axios.get('/admin/setting/getCartStyles');
            console.log('API Response (fetchCardStyles):', response);

            // 根据实际 API 返回的数据结构调整访问路径
            if (response && response.code === 200 && response.data) {
                commit('setCardStyles', response.data);
            } else {
                console.error('API 返回的数据结构不正确:', response);
            }
        } catch (error) {
            console.error('获取卡片样式失败:', error);
            throw error;
        }
    },

    /**
     * 更新卡片样式
     */
    async updateCardStyles({ commit }, newStyles) {
        try {
            console.log(newStyles)
            const response = await axios.post('/admin/setting/updateCartStyles', newStyles);
            console.log(response)
            if (response.code === 200 && response.data) {
                commit('setCardStyles', response.data);
            } else {
                console.error('更新卡片样式失败:', response.msg);
                throw new Error(response.msg || '更新卡片样式失败');
            }
        } catch (error) {
            console.error('更新卡片样式失败:', error);
            throw error;
        }
    },
};

const mutations = {
    setCardStyles(state, styles) {
        state.cardStyles = styles;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
